export const STATUS_TO_COLOR_MAP = {
  NOT_STARTED: 'black',
  IN_PROGRESS: 'yellow',
  ACKNOWLEDGED: 'green',
  SUBMITTED: 'green',
};
export const STATUS_TO_LABEL_MAP = {
  NOT_STARTED: 'Not Started',
  IN_PROGRESS: 'In Progress',
  ACKNOWLEDGED: 'Completed',
  SUBMITTED: 'Completed',
};

export const REVIEW_RATING_TYPES = {
  OVERALL: 'OVERALL',
  PERFORMANCE: 'PERFORMANCE',
  POTENTIAL: 'POTENTIAL',
  QNA: 'QNA',
  PROMOTION: 'PROMOTION',
  OUTCOME: 'OUTCOME',
};
